import { CheckInOption, TenantBuildingSettingsOverride } from 'store/building-settings/types';
import { useCallback } from 'react';

interface UseUserCheckInOptionsResponse {
  userShouldStopAtDesk: (
    availableCheckInOptions: CheckInOption,
    tenantOverride: TenantBuildingSettingsOverride,
  ) => boolean;
  userShouldBypassDesk: (
    availableCheckInOptions: CheckInOption,
    tenantOverride: TenantBuildingSettingsOverride,
  ) => boolean;
}

export const useUserCheckInOptions = (): UseUserCheckInOptionsResponse => {
  const userShouldStopAtDesk = useCallback(
    (availableCheckInOptions: CheckInOption, tenantOverride: TenantBuildingSettingsOverride) =>
      availableCheckInOptions === CheckInOption.STOP_AT_DESK ||
      tenantOverride?.availableCheckInOptions === CheckInOption.STOP_AT_DESK,
    [],
  );

  const userShouldBypassDesk = useCallback(
    (availableCheckInOptions: CheckInOption, tenantOverride: TenantBuildingSettingsOverride) =>
      availableCheckInOptions === CheckInOption.BYPASS_DESK ||
      tenantOverride?.availableCheckInOptions === CheckInOption.BYPASS_DESK,
    [],
  );
  return { userShouldStopAtDesk, userShouldBypassDesk };
};
